import { render, staticRenderFns } from "./accessibility-dropdown.vue?vue&type=template&id=42fa7d1c&scoped=true&"
import script from "./accessibility-dropdown.vue?vue&type=script&lang=ts&"
export * from "./accessibility-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./accessibility-dropdown.vue?vue&type=style&index=0&id=42fa7d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa7d1c",
  null
  
)

export default component.exports